import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password berhasil direset. Silakan masuk.");
      nav("/login");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="reset-form">
        <h1 className="text-3xl font-semibold text-slate-900">Reset Password</h1>
        <p className="text-sm text-slate-500">Masukkan password baru Anda.</p>
        <div className="space-y-2">
          <Label>Password Baru</Label>
          <Input data-testid="reset-password" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} minLength={6} required/>
        </div>
        <Button type="submit" disabled={loading || !token} data-testid="reset-submit" className="w-full brand-btn rounded-sm">
          {loading ? "Menyimpan..." : "Simpan Password"}
        </Button>
        <div className="text-sm"><Link to="/login" className="text-[color:var(--brand)] hover:underline">← Kembali ke Login</Link></div>
      </form>
    </div>
  );
}
